import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ReportsService {
    /**
     * Get Store Performance Report
     * @param request: FiltersForQuery
     * @return: url to the pdf file which is stored in GCP and is valid for 7 days
     * @param reportId
     * @param requestBody
     * @returns string Successful Response
     * @throws ApiError
     */
    static getStorePerformanceReportReportsGeneratePost(reportId, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/reports/generate',
            query: {
                'report_id': reportId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Trigger Report
     * @param report_type: LOOP_REPORT_TYPE
     * @param request: FiltersForQuery
     * @param user: User
     * @param db: Session
     * @return: list of LoopReportRun objects
     * @param reportType
     * @param requestBody
     * @returns LimitOffsetResponse Successful Response
     * @throws ApiError
     */
    static triggerReportReportsTriggerReportTypePost(reportType, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/reports/trigger/{report_type}',
            path: {
                'report_type': reportType,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Latest Runs
     * @param request: FiltersForQueryPaginated
     * @param db: Session
     * @return: list of LoopReportRun objects
     * @param requestBody
     * @returns LimitOffsetResponse Successful Response
     * @throws ApiError
     */
    static getLatestRunsReportsGetLatestRunsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/reports/get_latest_runs',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Report Types
     * @return: list of report types
     * @param chain
     * @returns any Successful Response
     * @throws ApiError
     */
    static getReportTypesReportsTypesGet(chain) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/reports/types',
            query: {
                'chain': chain,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Send Email
     * @param reportId
     * @param emailId
     * @param userName
     * @returns any Successful Response
     * @throws ApiError
     */
    static sendEmailReportsNotifyReportReadyReportIdPost(reportId, emailId, userName) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/reports/notify_report_ready/{report_id}',
            path: {
                'report_id': reportId,
            },
            query: {
                'email_id': emailId,
                'user_name': userName,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
